import { initProjectsExploreFilteredSearchAndSort } from '~/projects/explore';

initProjectsExploreFilteredSearchAndSort();
